import { useContext, useEffect } from "react";
import { CadviewerContext } from "../../../context/Cadviewer.Context";
import { AIChatV2, useAIChatStoreV2 } from "../stores/aiChatStoreV2";
import { ChatMessageV2 } from "../types/aiChatClientV2";
import { SearchCriteria } from "../types/search_engine";

export interface UseAIChatV2ReturnType {
  messages: ChatMessageV2[];
  isLoading: boolean;
  isSearching: boolean;
  error: string | null;
  sendMessage: (prompt: string) => Promise<void>;
  currentSearchCriteria: SearchCriteria | null;
  clearError: () => void;
  clearHistoryMessagesToSend: () => void;
  internalCADViewerAICallback: (chatMessage: ChatMessageV2) => void;
  currentHighlight: string | null;
  clearCurrentHighlight: () => void;
}

export function useAIChatV2(): UseAIChatV2ReturnType {
  const { plansInfo, distanceData, selectedPlan, selectedPlanDetail } = useContext(CadviewerContext);
  //console.log({ plansInfo, distanceData });
  const spacesNames =
    plansInfo?.spaces.map((space) => ({
      name: space.spaceHeader,
      dbas: [], // space.detailTabs.map((tab) => tab.detail.DBA),
    })) || [];

  // Utiliser directement les propriétés du store avec destructuring
  const messages = useAIChatStoreV2((state: AIChatV2) => state.messages);
  const isLoading = useAIChatStoreV2((state: AIChatV2) => state.isLoading);
  const isSearching = useAIChatStoreV2((state: AIChatV2) => state.isSearching);
  const error = useAIChatStoreV2((state: AIChatV2) => state.error);
  const currentSearchCriteria = useAIChatStoreV2(
    (state: AIChatV2) => state.currentSearchCriteria
  );
  const currentHighlight = useAIChatStoreV2(
    (state: AIChatV2) => state.currentHighlight
  );
  const clearCurrentHighlight = useAIChatStoreV2(
    (state: AIChatV2) => state.clearCurrentHighlight
  );
  const sendMessage = useAIChatStoreV2((state: AIChatV2) => state.sendMessage);
  const mockSendMessage = async (
    prompt: string,
    useGlobalMode: boolean = false,
    selectedSpaces?: string[]
  ) => {
    await sendMessage(
      prompt,
      spacesNames,
      selectedPlan,
      selectedPlanDetail,
      useGlobalMode,
      selectedSpaces
    );
  };
  const clearError = useAIChatStoreV2((state: AIChatV2) => state.clearError);
  const clearHistoryMessagesToSend = useAIChatStoreV2(
    (state: AIChatV2) => state.clearHistoryMessagesToSend
  );
  const internalCADViewerAICallback = useAIChatStoreV2(
    (state: AIChatV2) => state.internalCADViewerAICallback
  );
  const setPlansInfoAndDistanceData = useAIChatStoreV2(
    (state: AIChatV2) => state.setPlansInfoAndDistanceData
  );

  // Synchroniser les données du context avec le store
  useEffect(() => {
    setPlansInfoAndDistanceData(plansInfo, distanceData);
  }, [plansInfo, distanceData, setPlansInfoAndDistanceData]);

  return {
    messages,
    isLoading,
    isSearching,
    error,
    sendMessage: mockSendMessage,
    currentSearchCriteria,
    clearError,
    clearHistoryMessagesToSend,
    internalCADViewerAICallback,
    currentHighlight,
    clearCurrentHighlight,
  };
}
